import React from "react"
import {MainCP} from "../../Components/futbolista-mas-destacado/MainCP"

const ViewFutbolistaMasDestacado: React.FC = () => <MainCP/>

export default ViewFutbolistaMasDestacado;